import {
  isString,
  transform,
} from 'lodash-es';

import type { ITranslationsKeyMap } from '@modules/i18n/types';
import type { IBackendTranslationsData } from '@modules/translate-manager/types';
import { isArrayOf } from '@utils/guards';

export default function prepareBackendTranslations(
  values: IBackendTranslationsData,
  result: ITranslationsKeyMap = {},
): ITranslationsKeyMap {
  return transform(
    values,
    (acc, value, key) => {
      if (isArrayOf(isString, value)) {
        acc[key] = transform(
          value,
          (res, val) => {
            res[val] = '';
          },
          {} as ITranslationsKeyMap,
        );
        return acc;
      }

      const mapTable = {};
      acc[key] = mapTable;
      return prepareBackendTranslations(value, mapTable);
    },
    result,
  );
}
